import React from 'react'
import css from './style.css'

const Table = props => (
  <table className={css.table}>
    {props.children}
  </table>
)

const TableHead = props => (
  <thead className={css.tableHead}>
    {props.children}
  </thead>
)

const TableBody = props => (
  <tbody>
    {props.children}
  </tbody>
)

const TableRow = props => {
  const rowClassNames = [
    css.tableRow,
    props.customStyle,
    props.checked ? css.checked : ''
  ]

  return (
    <tr className={rowClassNames.join(' ')}>
      {props.children}
    </tr>
  )
}

const TableData = props => (
  <td className={css.tableData} style={{width: props.width}}>
    {props.children}
  </td>
)

export { Table, TableHead, TableBody, TableRow, TableData }



// WEBPACK FOOTER //
// ./src/components/table/index.js